// initial state
import axios from "axios";

let baseURL = 'https://admin.hoptone.com/api/';
const debug = process.env.NODE_ENV !== 'production';

if (debug) {
    baseURL = 'http://hoptone.test/api/'
} else {
    baseURL = 'https://admin.hoptone.com/api/'
}
const getDefaultState = () => {
    return {
        CDRS: [],
        lastUpdate: null,
        internalYear: [],
        internalMonth: [],
        externalYear: [],
        externalMonth: [],
        status: null,
    };
};

const state = {
    CDRS: [],
    internalYear: [],
    internalMonth: [],
    externalYear: [],
    externalMonth: [],
    lastUpdate: null,
    status: null,
};

// getters
const getters = {
    needUpdate: (state) => {
        if (state.status === 'SUCCESS' && state.CDRS.length > 0) {
            return false;
        }

        return true;
    },
    amount(state) {
        return state.CDRS.length;
    },
    isLoading(state) {
        return state.status === 'LOADING';
    },
    CDRS(state) {
        return state.CDRS;
    },
    internalYear(state) {
        return state.internalYear;
    },
    internalMonth(state) {
        return state.internalMonth;
    },
    externalYear(state) {
        return state.externalYear;
    },
    externalMonth(state) {
        return state.externalMonth;
    }
};

// actions
const actions = {
    resetState({commit}) {
        commit('resetState')
    },
    loadCDRS: ({commit, dispatch}, options = {}) => {
        return new Promise((resolve, reject) => {
            commit('SET_LOADING');
            axios({
                url: baseURL + 'cdr/recent', method: 'GET', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
                params: options,
            })
                .then(resp => {
                    commit('SET_SUCCESS');
                    commit('SET_CDRS', resp.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('SET_ERROR');
                    reject(err)
                })
        })
    },
    loadInternalYear: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit('SET_LOADING');
            axios({
                url: baseURL + 'cdr/internal/year', method: 'GET', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            })
                .then(resp => {
                    commit('SET_SUCCESS');
                    commit('SET_CDRS_INTERNAL_YEAR', resp.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('SET_ERROR');
                    reject(err)
                })
        })
    },
    loadExternalYear: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit('SET_LOADING');
            axios({
                url: baseURL + 'cdr/external/year', method: 'GET', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            })
                .then(resp => {
                    commit('SET_SUCCESS');
                    commit('SET_CDRS_EXTERNAL_YEAR', resp.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('SET_ERROR');
                    reject(err)
                })
        })
    },
    loadInternalMonth: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit('SET_LOADING');
            axios({
                url: baseURL + 'cdr/internal/month', method: 'GET', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            })
                .then(resp => {
                    commit('SET_SUCCESS');
                    commit('SET_CDRS_INTERNAL_MONTH', resp.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('SET_ERROR');
                    reject(err)
                })
        })
    },
    loadExternalMonth: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit('SET_LOADING');
            axios({
                url: baseURL + 'cdr/external/month', method: 'GET', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            })
                .then(resp => {
                    commit('SET_SUCCESS');
                    commit('SET_CDRS_EXTERNAL_MONTH', resp.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('SET_ERROR');
                    reject(err)
                })
        })
    },

};

// mutations
const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState())
    },
    SET_CDRS: (state, CDRS) => state.CDRS = CDRS,
    SET_CDRS_INTERNAL_YEAR: (state, CDRS) => state.internalYear = CDRS,
    SET_CDRS_INTERNAL_MONTH: (state, CDRS) => state.internalMonth = CDRS,
    SET_CDRS_EXTERNAL_YEAR: (state, CDRS) => state.externalYear = CDRS,
    SET_CDRS_EXTERNAL_MONTH: (state, CDRS) => state.externalMonth = CDRS,
    SET_LOADING: (state) => state.status = 'LOADING',
    SET_SUCCESS: (state) => state.status = 'SUCCESS',
    SET_ERROR: (state) => state.status = 'ERROR',

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
